module.exports = __webpack_public_path__ + "Flag-51.11167d967f6b1c46a9de92a898a424a5.svg";